<template>
	<div class="remote">
		<div class="remote-inner">
			<div class="remote-inner-wrap">
				<div class="lf">
					<div class="lf-top">
						<div class="logo">
							<img class="animate" v-lazy="remoteLogo" alt="">
						</div>
						<div class="intro">
							<p class="animate">{{ $t('remote.intro')}}</p>
						</div>
						<div class="download" @click="onDownload">
							<span class="iconfont icon-anzhuoxiazai"></span>
							<a href="javascript: void 0" class="text">{{ $t('remote.download') }}</a>
						</div>
						<div class="notes">
							<span>*{{ $t('remote.note') }}</span>
							<span class="specia-clr">{{ $t('remote.andriod') }}</span>
						</div>
					</div>
					<div class="lf-bottom">
						<div class="features-list">
							<div class="fn" v-for="(fn, idx) in fnList" :key="idx" @click="onSwitch(idx)">
								<span class="iconfont" :class="[fn.icon, { active: idx === curIndex }]"></span>
							</div>
						</div>
						<div class="intro">
							<p>{{ $t(`remote.${curData.cate}_intro`) }}</p>
						</div>
					</div>
				</div>
				<div class="rgt">
					<img  :src="`/res/img/${curData.src}`" alt="">
					<!-- 小屏样式 -->
					<div class="ml-bottom">
						<div class="features-list">
							<div class="fn" v-for="(fn, idx) in fnList" :key="idx" @click="onSwitch(idx)">
								<span class="iconfont" :class="[fn.icon, { active: idx === curIndex }]"></span>
							</div>
						</div>
						<div class="intro">
							<p>{{ $t(`remote.${curData.cate}_intro`) }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="scene">
				<div class="custom">
					<img v-lazy="sceneLogo" alt="">
				</div>
				<div class="rec-card">
					<div class="title">
						<h2 class="animate">{{ $t('remote.fbTitle') }}</h2>
						<h2 class="specia-clr animate">{{ $t('remote.fbSecTitle') }}</h2>
					</div>
					<div class="intro">
						<span>{{ $t('remote.fbIntro') }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TvRemote',
		components: {},
		data() {
			return {
				curIndex: 0,
				remoteLogo: require('@/static/img/aurora-remote-logo.png'),
				sceneLogo: require('@/static/img/icon-scene-img.png'),
				fnList: [{
						cate: 'open', 
						icon: 'icon-miaokaiyingyong',
						src: 'remote-img-1.png',
					},
					{
						cate: 'ipt',
						icon: 'icon-huakong',
						src: 'remote-img-2.png',
					},
					{
						cate: 'file',
						icon: 'icon-kuaisushuru',
						src: 'remote-img-3.png',
					},
					{
						cate: 'ctl',
						icon: 'icon-wenjianchuanshu',
						src: 'remote-img-4.png',
					}
				]
			};
		},
		computed: {
			curData() {
				return this.fnList[this.curIndex]
			}
		},
		methods: {
			onSwitch(i) {
				this.curIndex = i
			},
			onDownload() {
				const link = document.createElement('a')
				link.href = '/res/download/auroraremote.apk'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.remote {
		padding-top: 120px;

		.remote-inner {
			max-width: 1280px;
			margin: 0 auto;
			padding: 0 24px;

			.remote-inner-wrap {
				position: relative;
				display: flex;
				align-items: center;
				border-radius: 32px;
				background: linear-gradient(#1D4346 0%, rgba(84, 102, 158, 0) 100%);

				/* background: linear-gradient( #54669e 0%, #1D4635 100%); */
				.lf {
					padding: 54px 33px 54px 54px;
					width: 50%;

					.lf-top {
						.logo {
							max-width: 271px;
							height: 33px;

							img {
								width: 100%;
								height: 100%;
							}
						}

						.intro {
							font-size: 15px;
							padding: 27px 0 16px;
						}

						.download {
							display: inline-block;
							padding: 12px 16px;
							background: #1EF8A0;
							border-radius: 31px;
							color: #192940;
							font-size: 14px;

							.iconfont {}

							.text {
								color: #192940;
								font-family: 'Alibaba PuHuiTi B';
							}
						}

						.notes {
							padding-top: 14px;
							font-size: 11px;

							.specia-clr {
								color: #1EF8A0;
							}
						}
					}

					.lf-bottom {
						padding-top: 60px;

						.features-list {
							position: relative;
							z-index: 101;
							display: flex;
							gap: 27px;
							padding-bottom: 16px;

							.fn {
								.iconfont {
									cursor: pointer;
									color: #8a949d;
									font-size: 33px;
								}

								.active {
									color: #17ffa1 !important;
								}
							}
						}

						.intro {
							font-size: 15px;
						}
					}
				}

				.rgt {
					position: absolute;
					right: 0;
					top: -115px;


					img {
						max-width: 466px;
						max-height: 586px;
					}

					.ml-bottom {
						display: none;
					}
				}
			}

			.scene {
				display: flex;
				gap: 33px;
				justify-content: space-between;
				padding: 54px 54px 0;

				.custom {
					max-width: 380px;
					max-height: 253px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.rec-card {
					padding-top: 38px;

					.title {
						h2 {
							font-size: 33px;
						}

						.specia-clr {
							color: #1EF8A0;
						}
					}

					.intro {
						padding: 24px 0;
					}

					.btn {
						flex: none;
						display: inline-block;
						text-align: center;
						padding: 12px 16px;
						color: #fff;
						border-radius: 31px;
						background: rgba(255, 255, 255, 0.1);
						cursor: pointer;
					}
				}
			}
		}
	}

	@media (max-width: 768px) {
		.remote{
			padding-top: 0 !important;
		}
		.remote-inner{
			padding: 0 !important;
		}
		.remote-inner-wrap {
			flex-direction: column;

			.lf {
				padding: 24px 24px 0 !important;
				width: 100% !important;
			}

			.notes {
				vertical-align: bottom;
				padding-left: 12px;
				display: inline-block !important;
			}

			.rgt {
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 100%;
				position: static !important;

				img {
					max-width: 100% !important;
				}
			}

			.lf-bottom {
				display: none;
			}

			.ml-bottom {
				display: block !important;
				padding: 24px;

				.features-list {
					display: flex;
					justify-content: space-between;

					gap: 27px;
					padding-bottom: 16px;

					.fn {
						.iconfont {
							cursor: pointer;
							color: #8a949d;
							font-size: 33px;
						}

						.active {
							color: #17ffa1 !important;
						}
					}
				}

				.intro {
					font-size: 15px;
				}
			}
		}

		.scene {
			padding: 0 24px !important;
			flex-direction: column-reverse;

			.rec-card {
				padding-top: 0 !important;
			}
		}
	}
</style>